import axios from "axios";
import config from "../config";

const persistInterval = 24 * 60 * 60 * 1000; // 1 day
const remotePersistInterval = 10 * 1000; // 10 sec

const plugin = (store) => {
	store.subscribe((mutation, state) => {
		// Save to local storage all the changes made in the cart state
		let uniq_id = state.classified ? state.classified.uniq_id : "";
		if (
			[
				"setStep",
				"setProfil",
				"setAuthor",
				"setCategory",
				"SET_CLASSIFIED",
				"setMode",
				"setFormat",
				"setDuration",
				"setStartDate",
				"setEndDate",
				"setMembership",
				"setTitle",
				"setStatus",
				"addMedia",
				"removeMedia",
				"setContent",
				"setProfession",
				"setRegion",
				"setContact",
				"setMedias",
				"setLogo",
				"removeLogo",
				"setOption",
				"FORCE_SAVE",
			].find((type) => type == mutation.type)
		) {
			let record = {
				data: {
					classified: state.classified,
					step: state.step,
				},
				ts: new Date().getTime() + persistInterval,
			};
			try {
				localStorage.setItem(
					"my_classified-" + uniq_id,
					JSON.stringify(record)
				);
			} catch (e) {}

			if (state.classified.title && state.classified.content) {
				if (
					[
						"FORCE_SAVE",
						"setOption",
						// , "setLogo", "removeLogo", "addMedia", "removeMedia"
					].includes(mutation.type) ||
					state.remote_ts == null ||
					new Date().getTime() > state.remote_ts
				) {
					store.commit(
						"setRemote",
						new Date().getTime() + remotePersistInterval
					);

					store.commit("startXhr");
					axios
						.post(
							config.app.gateway + "?action=classified_v2_save_classified",
							{
								action: "classified_v2_save_classified",
								classified: state.classified,
								force_save: mutation.type == "FORCE_SAVE",
								is_admin: state.is_admin,
							},
							{
								headers: {
									"Content-Type": "application/json",
								},
							}
						)
						.then((response) => {
							if (state.classified.uniq_id == null) {
								state.classified.uniq_id = response.data.uniq_id;
								store.commit("SET_CLASSIFIED", state.classified);
							}
						})
						.finally(() => store.commit("endXhr"));
				}
			}
		}

		if ("initClassified" == mutation.type) {
			localStorage.removeItem("my_classified-" + uniq_id);
		}

		if ("SET_CLASSIFIED" === mutation.type) {
			if (!state.classified.uniq_id) return;

			let formData = new FormData();
			formData.append("uniq_id", state.classified.uniq_id);
			store.commit("startXhr");
			axios
				.post(
					config.app.gateway + "?action=classified_v2_get_classified_medias",
					formData,
					{
						// headers: {
						//   "Content-Type": "multipart/form-data"
						// }
					}
				)
				.then((response) => {
					store.commit("setAllMedias", response.data);
				})
				.catch((response) => {
					//
				})
				.finally(() => store.commit("endXhr"));

			formData = new FormData();
			formData.append("uniq_id", state.classified.uniq_id);
			store.commit("startXhr");
			axios
				.post(
					config.app.gateway + "?action=classified_v2_get_classified_logo",
					formData,
					{
						// headers: {
						//   "Content-Type": "multipart/form-data"
						// }
					}
				)
				.then((response) => {
					store.commit("setLogoMedia", response.data);
				})
				.catch((response) => {
					//
				})
				.finally(() => store.commit("endXhr"));

			// }
		}
	});
};

export default plugin;
